import React from "react";
import "./ConsultationForm.css";

const ConsultationForm = () => {
  return (
    <section
      className="consultation-form-section"
      style={{
        backgroundImage: "url('/img/form.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)", // makes background truly edge-to-edge
        borderRadius: "0",
        padding: "80px 0",
        color: "#fff",
        position: "relative",
        marginTop: "40px"
      }}
    >
      <div className="overlay"></div> {/* optional dark overlay for contrast */}

      <div className="container position-relative">
        <h2 className="text-center mb-4 fw-bold text-white">
          Get a Free Consultation
        </h2>

        <form className="consultation-form">
          <div className="row g-3 mb-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control input-glass"
                placeholder="Name"
              />
            </div>
            <div className="col-md-4">
              <input
                type="email"
                className="form-control input-glass"
                placeholder="Email"
              />
            </div>
            <div className="col-md-4">
              <input
                type="tel"
                className="form-control input-glass"
                placeholder="Phone Number"
              />
            </div>
          </div>

          <div className="row mb-3 align-items-center">
            <div className="col-md-6">
              <label className="form-label fw-bold text-light">
                Requirement <span className="text-danger">*</span>
              </label>
              <div className="d-flex flex-wrap gap-3 mt-2">
                <label><input type="checkbox" /> Architectural Design</label>
                <label><input type="checkbox" /> Interior Design</label>
                <label><input type="checkbox" /> Makeover & Renovation</label>
              </div>
            </div>

            <div className="col-md-6">
              <label className="form-label fw-bold text-light">
                Unit Type <span className="text-danger">*</span>
              </label>
              <div className="d-flex flex-wrap gap-3 mt-2">
                <label><input type="checkbox" /> 1BHK</label>
                <label><input type="checkbox" /> 2BHK</label>
                <label><input type="checkbox" /> 3BHK</label>
                <label><input type="checkbox" /> Villa</label>
                <label><input type="checkbox" /> Commercial</label>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn btn-warning px-5 py-2 rounded-pill fw-bold"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ConsultationForm;
